<template>
  <div class="wrapper">
    <div class="center-title">{{detail.title}}</div>
    <div v-if="$route.query.otype==2" class="org-zt">
      <div class="content">
				<div class="left">
          <a @click="goDutyOnce(item)" v-for="(item,i) in detail.list1" :key='i'>
            {{item}}
          </a>
				</div>
        <a class="cen" v-for="(item,i) in detail.list2" :key='i' @click="goDutyOnce(item)">{{item}}</a>
				<div class="right">
					<div class="right-top">
						<a @click="goDutyOnce(item)" v-for="(item,i) in detail.list3" :key='i'>{{item.replace(/︵/g,'(').replace(/︶/g,')').replace(/&lt;br\/&gt;/g,'')}}</a>
						<span :style="{'height':detail.list3&&(detail.list3.length-1)*1.479+'rem'}" class="line"></span>
					</div>
					<div class="right-bottom">
						<a @click="goDutyOnce(item,'no')" v-for="(item,i) in listdownRight" :key='i'>
              {{item}}
            </a>
						<span class="line"></span>
					</div>
				</div>
			</div>
			<div class="box">
				<span class="box-solid"></span>
				直接领导
				<span class="box-hollow"></span>
				业务监督指导
			</div>
    </div>
    <div class="center-text ql-editor" v-html="detail.content" v-else></div>
  </div>
</template>
<script>
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      detail: {},
      listdownRight: []
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    ...mapActions(["firstTitle", "secondTitle"]),
    getDetail() {
      if (this.$route.query.otype == 1) {
        this.secondTitle("中心简介");
      } else if (this.$route.query.otype == 2) {
        this.secondTitle("组织架构图");
      } else if (this.$route.query.otype == 3) {
        this.secondTitle("中心领导");
      } else if (this.$route.query.otype == 5) {
        this.secondTitle("资质证书");
      } else {
        this.secondTitle("部门职责");
      }
      if(this.$route.query.otype=='2'){
        userApi.department().then(res => {
          this.listdownRight = res.data.list3.splice(-3)
          this.detail = res.data;
        });
      }else{
        userApi.organizationdetail({ type: this.$route.query.otype }).then(res => {
          this.detail = res.data;
        });
      }
    },
		goDutyOnce(name,tk){
      if(tk==='no'){
        return;
      }
      if(name==='自然资源部'){
        location.href = 'http://www.mnr.gov.cn/'
      }else if(name==='国家市场监督管理总局'){
        location.href = 'http://www.samr.gov.cn/'
      }else{
        this.$router.push({
          path: '/org/duty',
          query:{
            name: window.encodeURI(name)
          }
        })
      }
    }
  },
  watch: {
    $route() {
      this.getDetail();
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
@import "./../../../common/minix.less";
.wrapper {
  padding: 30 / @rem 0;
  box-sizing: border-box;
  background: #f2f2f2;
  .center-title {
    text-align: center;
    font-size: 36 / @rem;
    margin-bottom: 30 / @rem;
    font-weight: 600;
  line-height: 56 / @rem;
  }
  .center-text {
    padding: 0 30 / @rem;
    font-size: 30 / @rem;
  }
  .center-text /deep/ p {
    font-size: 30 / @rem;
    color: #222;
    line-height: 48 / @rem;
    // margin-bottom: 30 / @rem;
    text-align: justify;
  }
  .center-text /deep/ h1 {
    font-size: 48 / @rem;
    margin-bottom: 20 / @rem;
  }
  .center-text /deep/ h2 {
    font-size: 44 / @rem;
    margin-bottom: 20 / @rem;
    font-weight: 600;
  }
  .center-text /deep/ h3 {
    font-size: 36 / @rem;
    margin-bottom: 20 / @rem;
    font-weight: 600;
  }
  .center-text /deep/ h4 {
    font-size: 32 / @rem;
    margin-bottom: 20 / @rem;
    font-weight: 600;
  }
  .center-text /deep/ h5 {
    font-size: 27 / @rem;
    margin-bottom: 20 / @rem;
    font-weight: 600;
  }
  .center-text /deep/ h6 {
    font-size: 25 / @rem;
    margin-bottom: 20 / @rem;
    font-weight: 600;
  }

  .center-text /deep/ img {
    display: block;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
  }
  .org-zt{
    .content{
			// width:100%;
			height:100%;
			display: flex;
			justify-content: flex-start;
      margin-bottom: 100 / @rem;
		}
		.left{
			width:106 / @rem;
      margin-top:110 / @rem;
      margin-right: 6 / @rem;
      margin-left: 40 /@rem;
		}
		.left a{
			width:66 / @rem;
			height:350 / @rem;
			background: linear-gradient(0deg,rgba(88,136,224,1) 0%,rgba(60,102,182,1) 100%);
			color: #fff;
			display: block;
			font-size: 28 / @rem;
			text-align: center;
			border-radius: 4 / @rem;
      position: relative;
      padding: 100 / @rem 10 / @rem;
      box-sizing: border-box;
		}
		.left a:before{
			content: '';
			width:33 / @rem;
			height: 4 / @rem;
			background: #284FAA;
			position: absolute;
			top:175 / @rem;
			right:-34 / @rem;
		}
		.left a:last-child{
			width: 62 / @rem;;
			height: 326 / @rem;;
			padding-top: 10 / @rem;;
			border: 2 / @rem solid #284FAA;
			color: #284FAA;
			background: #fff;
			line-height: 30 / @rem;
			margin-top: 45 / @rem;
		}
		.left .left-a2:before{
			height: 0;
			border-top:2 / @rem dashed #284FAA;
			border-bottom:2 / @rem dashed #284FAA;
			background: #FFFFFF;
		}
		.cen{
			width:66 / @rem;
			height:660 / @rem;
			display: block;
			background:linear-gradient(0deg,rgba(88,136,224,1) 0%,rgba(60,102,182,1) 100%);
			color: #FFFFFF;
			font-size:28 / @rem;
			text-align: center;
			border-radius: 5 / @rem;
      margin-right: 16 / @rem;
      padding: 300 / @rem 10 / @rem 0;
    }
    .right{
      margin-left: 50 / @rem;
    }
		.right-top{
			position: relative;
		}
		.right-top .line{
			width:2 / @rem;
			height:692 / @rem;
			background: #4A88E7;
			display: block;
			position: absolute;
			left:-36 / @rem;
			top:30 / @rem;
		}
		.right-top .line:before{
			content: '';
			width:32/ @rem;
			height: 2 / @rem;
			background: #4A88E7;
			display: block;
			position: absolute;
			left:-32 / @rem;
			top:346 / @rem;
		}
		.right-top a{
			width:410 / @rem;
			padding-left: 30 / @rem;
			height:60 / @rem;
			border-radius: 5 / @rem;
			display: block;
			color: #FFFFFF;
			background: #4A88E7;
			font-size: 24 / @rem;
			margin-bottom: 9 / @rem;
			margin-right: 36 / @rem;
			position: relative;
			line-height: 60 / @rem;
		}
		.right-top a:last-child{
			margin-bottom: 0;
		}
		.right-top a:before{
			content: '';
			width:34 / @rem;
			height: 2 / @rem;
			background: #4A88E7;
			display: block;
			position: absolute;
			left:-34 / @rem;
			top:30 / @rem;
		}
		.right-bottom a{
			width:406 / @rem;
			padding-left: 30 / @rem;
			height: 56 / @rem;
			border:2 / @rem solid #284FAA;
			border-radius: 5 / @rem;
			display: block;
			font-size: 24 / @rem;
			line-height: 60 / @rem;
			background: #FFFFFF;
			color: #284FAA;
			margin-bottom: 9 / @rem;
			position: relative;
		}
		.right-bottom a:before{
			content: '';
			width:34 / @rem;
			display: block;
			position: absolute;
			left:-34 / @rem;
			top:30 / @rem;
			border-top:1 / @rem dashed #4A88E7;
			border-bottom:1 / @rem dashed #4A88E7;
		}
		.right-bottom{
			position: relative;
		}
		.right-bottom .line{
			border-left:1 / @rem dashed #4A88E7;
			border-right:1 / @rem dashed #4A88E7;
			height: 140 / @rem;
			display: block;
			position: absolute;
			left:-36 / @rem;
			top:32 / @rem;
		}
		.right-bottom .line:before{
			content: '';
			width:32 / @rem;
			border-top:1 / @rem dashed #4A88E7;
			border-bottom:1 / @rem dashed #4A88E7;
			display: block;
			position: absolute;
			left:-32 / @rem;
			top:68 / @rem;
		}
		.box{
			width:100%;
			padding-left:40 / @rem;
			display: flex;
			justify-content: flex-start;
			font-size:24 / @rem;
			color: #2553B2;
		}
		.box-solid{
			width:24 / @rem;
			height:24 / @rem;
			border-radius: 5 / @rem;
			background:#3E68B9 ;
			display: inline-block;
			vertical-align: top;
			margin: 4 / @rem 20 / @rem 0 20 / @rem;
		}
		.box-hollow{
			width:22 / @rem;
			height:22 / @rem;
			border:1 / @rem solid #3E68B9;
			display: block;
			border-radius: 5 / @rem;
			vertical-align: top;
			margin:4 / @rem 20 / @rem 0 20 / @rem;
		}
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Organization/Children/centerIntro.vue